import { memo } from 'react';

import { clsx } from 'clsx';

import cls from './Divider.module.scss';

type DividerProps = {
  className?: string;
};

export const Divider = memo<DividerProps>(({ className }) => <div className={clsx(cls.divider, className)} />);
